import axios from 'axios'

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

var httpupload = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
  })

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getApplicationConfig(callback) {
  var config = getConfig()
  var url = '/promotion/configs'
  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function saveApplicationConfig(data, callback) {
  var config = getConfig()
  var url = '/promotion/configs'
  http.put(url, data, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

export default {
  getApplicationConfig,
  saveApplicationConfig
}



// WEBPACK FOOTER //
// ./src/services/config_service.js